/* =========================================================
   MOOSH THEME — global.js
   Minimal vanilla JS. No dependencies. OS 2.0 friendly.
   ========================================================= */

(function () {
  'use strict';

  const Moosh = {
    money(cents) {
      if (window.Shopify && window.Shopify.currency) {
        try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify.currency.active }); }
        catch (e) { }
      }
      return '$' + (cents / 100).toFixed(2);
    },

    toast(msg) {
      const region = document.getElementById('ToastRegion');
      if (!region) return;
      const t = document.createElement('div');
      t.className = 'toast';
      t.textContent = msg;
      region.appendChild(t);
      setTimeout(() => t.remove(), 3200);
    },

    openOverlay() {
      let o = document.querySelector('.overlay');
      if (!o) {
        o = document.createElement('div');
        o.className = 'overlay';
        document.body.appendChild(o);
        o.addEventListener('click', Moosh.closeAll);
      }
      o.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    closeAll() {
      document.querySelectorAll('.cart-drawer.is-open, .search-drawer.is-open, .mobile-nav.is-open').forEach(el => el.classList.remove('is-open'));
      const o = document.querySelector('.overlay');
      if (o) o.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    // Cart API
    async cartAdd(formData) {
      const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart');
      }
      return r.json();
    },
    async cartGet() {
      const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      return r.json();
    },
    async cartChange(line, qty) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity: qty })
      });
      return r.json();
    },

    async refreshCart() {
      try {
        const cart = await Moosh.cartGet();
        const count = document.querySelector('[data-cart-count]');
        if (count) {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        const drawer = document.querySelector('[data-cart-drawer-body]');
        if (drawer) {
          Moosh.renderCart(cart);
        }
      } catch (e) { console.warn(e); }
    },

    renderCart(cart) {
      const body = document.querySelector('[data-cart-drawer-body]');
      const footer = document.querySelector('[data-cart-drawer-footer]');
      if (!body) return;

      if (!cart.items.length) {
        body.innerHTML = `<div style="text-align:center;padding:60px 20px;">
          <p style="color:var(--c-text-muted);margin-bottom:20px;">Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-primary" data-cart-close>Shop now</a>
        </div>`;
        if (footer) footer.style.display = 'none';
        return;
      }

      body.innerHTML = cart.items.map((item, i) => `
        <div class="cart-item" data-line="${i + 1}">
          <a href="${item.url}"><img src="${item.image ? item.image.replace(/\.(jpg|jpeg|png|webp)/i, '_160x.$1') : ''}" alt="${item.product_title}" loading="lazy"></a>
          <div>
            <a href="${item.url}" class="cart-item-title">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
            <div class="quantity-input">
              <button type="button" data-qty-change="-1" aria-label="Decrease">−</button>
              <input type="number" value="${item.quantity}" min="0" data-qty-input>
              <button type="button" data-qty-change="1" aria-label="Increase">+</button>
            </div>
          </div>
          <div style="text-align:right;display:flex;flex-direction:column;justify-content:space-between;align-items:flex-end;">
            <div class="cart-item-price">${Moosh.money(item.final_line_price)}</div>
            <button type="button" data-remove style="background:none;border:0;cursor:pointer;color:var(--c-text-muted);font-size:0.82rem;text-decoration:underline;padding:0;">Remove</button>
          </div>
        </div>
      `).join('');

      if (footer) {
        footer.style.display = 'block';
        const sub = footer.querySelector('[data-cart-subtotal]');
        if (sub) sub.textContent = Moosh.money(cart.total_price);

        const threshold = parseFloat(footer.dataset.freeShippingThreshold || '0');
        const progressWrap = footer.querySelector('[data-shipping-progress]');
        if (threshold > 0 && progressWrap) {
          const goalCents = threshold * 100;
          const pct = Math.min(100, (cart.total_price / goalCents) * 100);
          progressWrap.querySelector('.shipping-progress-bar').style.width = pct + '%';
          const txt = progressWrap.querySelector('.shipping-progress-text');
          if (cart.total_price >= goalCents) {
            txt.textContent = 'You qualify for free shipping';
          } else {
            txt.textContent = `Add ${Moosh.money(goalCents - cart.total_price)} more for free shipping`;
          }
        }
      }

      body.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const row = btn.closest('[data-line]');
          const line = parseInt(row.dataset.line, 10);
          const input = row.querySelector('[data-qty-input]');
          const delta = parseInt(btn.dataset.qtyChange, 10);
          const newQty = Math.max(0, parseInt(input.value, 10) + delta);
          await Moosh.cartChange(line, newQty);
          Moosh.refreshCart();
        });
      });

      body.querySelectorAll('[data-qty-input]').forEach(inp => {
        inp.addEventListener('change', async () => {
          const row = inp.closest('[data-line]');
          const line = parseInt(row.dataset.line, 10);
          const qty = Math.max(0, parseInt(inp.value, 10) || 0);
          await Moosh.cartChange(line, qty);
          Moosh.refreshCart();
        });
      });

      body.querySelectorAll('[data-remove]').forEach(btn => {
        btn.addEventListener('click', async () => {
          const row = btn.closest('[data-line]');
          const line = parseInt(row.dataset.line, 10);
          await Moosh.cartChange(line, 0);
          Moosh.refreshCart();
        });
      });
    },

    openCart() {
      const d = document.querySelector('.cart-drawer');
      if (d) { d.classList.add('is-open'); Moosh.openOverlay(); Moosh.refreshCart(); }
    },

    openSearch() {
      const d = document.querySelector('.search-drawer');
      if (d) {
        d.classList.add('is-open'); Moosh.openOverlay();
        const inp = d.querySelector('input[type="search"]');
        if (inp) setTimeout(() => inp.focus(), 150);
      }
    },

    openMobileNav() {
      const d = document.querySelector('.mobile-nav');
      if (d) { d.classList.add('is-open'); Moosh.openOverlay(); }
    },

    bindGlobal() {
      document.addEventListener('click', e => {
        const t = e.target.closest('[data-open-cart]');
        if (t) { e.preventDefault(); Moosh.openCart(); return; }
        const s = e.target.closest('[data-open-search]');
        if (s) { e.preventDefault(); Moosh.openSearch(); return; }
        const m = e.target.closest('[data-open-mobile-nav]');
        if (m) { e.preventDefault(); Moosh.openMobileNav(); return; }
        const c = e.target.closest('[data-close], [data-cart-close], [data-search-close], [data-mobile-nav-close]');
        if (c) { e.preventDefault(); Moosh.closeAll(); return; }
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') Moosh.closeAll();
      });

      // Product forms (add to cart)
      document.addEventListener('submit', async e => {
        const form = e.target.closest('form[action*="/cart/add"]');
        if (!form) return;
        if (form.hasAttribute('data-no-ajax')) return;
        e.preventDefault();
        const btn = form.querySelector('[type="submit"]');
        const original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
        try {
          await Moosh.cartAdd(new FormData(form));
          Moosh.openCart();
        } catch (err) {
          Moosh.toast(err.message);
        } finally {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        }
      });

      // PDP variant picker
      document.querySelectorAll('[data-variant-picker]').forEach(picker => {
        const form = picker.closest('form');
        const selects = picker.querySelectorAll('select[data-option-index], [data-option-index] [data-variant-chip]');
        picker.addEventListener('click', e => {
          const chip = e.target.closest('[data-variant-chip]');
          if (!chip) return;
          const group = chip.closest('[data-option-index]');
          group.querySelectorAll('[data-variant-chip]').forEach(c => c.setAttribute('aria-checked', 'false'));
          chip.setAttribute('aria-checked', 'true');
          Moosh.syncVariant(form, picker);
        });
        picker.addEventListener('change', e => {
          if (e.target.matches('select[data-option-index]')) Moosh.syncVariant(form, picker);
        });
      });

      // PDP gallery
      document.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
        const main = gallery.querySelector('[data-pdp-main]');
        gallery.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
          thumb.addEventListener('click', () => {
            gallery.querySelectorAll('[data-pdp-thumb]').forEach(t => t.setAttribute('aria-current', 'false'));
            thumb.setAttribute('aria-current', 'true');
            const src = thumb.dataset.fullsrc;
            const img = main.querySelector('img');
            if (img && src) img.src = src;
          });
        });
      });

      // Quantity inputs on PDP
      document.querySelectorAll('[data-pdp-qty]').forEach(wrap => {
        const input = wrap.querySelector('input');
        wrap.querySelectorAll('button').forEach(btn => {
          btn.addEventListener('click', () => {
            const delta = parseInt(btn.dataset.qtyChange, 10);
            input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
          });
        });
      });

      // Predictive search
      const searchInput = document.querySelector('[data-predictive-search]');
      if (searchInput) {
        const results = document.querySelector('[data-predictive-results]');
        let timer;
        searchInput.addEventListener('input', () => {
          clearTimeout(timer);
          const q = searchInput.value.trim();
          if (q.length < 2) { if (results) results.innerHTML = ''; return; }
          timer = setTimeout(async () => {
            try {
              const r = await fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last`);
              const data = await r.json();
              const rs = data.resources.results;
              let html = '';
              if (rs.products && rs.products.length) {
                html += '<h4 style="margin:20px 0 10px;">Products</h4><div class="product-grid" style="grid-template-columns:repeat(auto-fill,minmax(180px,1fr));">';
                html += rs.products.map(p => `
                  <a href="${p.url}" class="product-card">
                    <div class="product-card-media"><img src="${p.image ? p.image.replace(/\.(jpg|jpeg|png|webp)/i, '_400x.$1') : ''}" alt="${p.title}" loading="lazy"></div>
                    <div class="product-card-body"><div class="product-card-title">${p.title}</div><div class="product-card-price">${p.price}</div></div>
                  </a>
                `).join('');
                html += '</div>';
              }
              if (rs.pages && rs.pages.length) {
                html += '<h4 style="margin:20px 0 10px;">Pages</h4><ul style="list-style:none;padding:0;">' +
                  rs.pages.map(p => `<li style="padding:8px 0;"><a href="${p.url}">${p.title}</a></li>`).join('') + '</ul>';
              }
              if (rs.articles && rs.articles.length) {
                html += '<h4 style="margin:20px 0 10px;">Articles</h4><ul style="list-style:none;padding:0;">' +
                  rs.articles.map(a => `<li style="padding:8px 0;"><a href="${a.url}">${a.title}</a></li>`).join('') + '</ul>';
              }
              if (!html) html = `<p style="color:var(--c-text-muted);padding:20px 0;">No results for "${q}".</p>`;
              if (results) results.innerHTML = html;
            } catch (e) { console.warn(e); }
          }, 220);
        });
      }
    },

    syncVariant(form, picker) {
      if (!form || !form._productData) return;
      const data = form._productData;
      const options = [];
      picker.querySelectorAll('[data-option-index]').forEach(group => {
        const chip = group.querySelector('[data-variant-chip][aria-checked="true"]');
        const select = group.querySelector('select[data-option-index]');
        if (chip) options.push(chip.dataset.optionValue);
        else if (select) options.push(select.value);
      });
      const variant = data.variants.find(v => v.options.every((o, i) => o === options[i]));
      const idInput = form.querySelector('input[name="id"]');
      const priceEl = document.querySelector('[data-pdp-price]');
      const atc = form.querySelector('[data-pdp-atc]');

      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          let html = `<span>${Moosh.money(variant.price)}</span>`;
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html = `<s>${Moosh.money(variant.compare_at_price)}</s>` + html + ` <span class="savings">Save ${Moosh.money(variant.compare_at_price - variant.price)}</span>`;
          }
          priceEl.innerHTML = html;
        }
        if (atc) {
          if (variant.available) { atc.disabled = false; atc.querySelector('[data-atc-text]').textContent = 'Add to cart'; }
          else { atc.disabled = true; atc.querySelector('[data-atc-text]').textContent = 'Sold out'; }
        }
        // Update URL
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    },

    bindReveals() {
      // Auto-apply reveal to common section containers.
      const autoSelectors = '.section-head, .product-grid, .content-grid, .compare, .feature-grid, .format-list, .review-rail, .paths, .usage-grid, .wholesale-banner, .wholesale-hero, .pdp-info, .pdp-gallery, .feature-card, .compare-card, .review-card, .content-card, .product-card, .format-card, .trust-item';
      document.querySelectorAll(autoSelectors).forEach(el => {
        if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', '');
      });

      // Respect reduced motion — CSS already handles the static fallback.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.querySelectorAll('[data-reveal]').forEach(el => el.dataset.revealed = 'true');
        return;
      }
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('[data-reveal]').forEach(el => el.dataset.revealed = 'true');
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.dataset.revealed = 'true';
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
    },

    bindHeaderOverlay() {
      const header = document.querySelector('.site-header');
      const hero = document.querySelector('.hero');
      if (!header || !hero) return;

      const update = () => {
        const heroBottom = hero.getBoundingClientRect().bottom;
        // Header is overlaying the hero while the hero's bottom is still below the header's height
        const overlay = heroBottom > 100;
        header.classList.toggle('is-overlay', overlay);
      };
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { update(); ticking = false; });
      }, { passive: true });
      update();
    },

    bindParallax() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const items = document.querySelectorAll('[data-parallax]');
      if (!items.length) return;
      let ticking = false;
      const update = () => {
        const vh = window.innerHeight;
        items.forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          const speed = parseFloat(el.dataset.parallax) || 0.1;
          // Center of element relative to viewport center, normalized to [-1, 1]
          const center = rect.top + rect.height / 2;
          const offset = (center - vh / 2) / vh;
          const y = -offset * speed * 100;
          el.style.transform = `translateY(${y.toFixed(2)}px)`;
        });
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      }, { passive: true });
      update();
    },

    init() {
      Moosh.bindGlobal();
      Moosh.bindReveals();
      Moosh.bindParallax();
      Moosh.bindHeaderOverlay();
      Moosh.refreshCart();
      window.Moosh = Moosh;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', Moosh.init);
  } else {
    Moosh.init();
  }
})();
